export default __webpack_public_path__ + "static/media/Kwiat-Cover-Image.0b77c279.jpg";